<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">

        <a-form-item label="销售渠道名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['channelName', validatorRules.channelName]" placeholder="请输入销售渠道名称"></a-input>
        </a-form-item>
        <a-form-item label="销售渠道状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="list" v-decorator="['channelState', validatorRules.channelState]" :trigger-change="true" dictCode="valid_status" placeholder="请选择销售渠道状态"/>
        </a-form-item>
        <a-form-item label="销售渠道代码" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['channelCode', validatorRules.channelCode]" placeholder="请输入销售渠道代码"></a-input>
        </a-form-item>

      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"



  export default {
    name: "SalesChannelModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          channelName: {
            rules: [
              { required: true, message: '请输入销售渠道名称!'},
            ]
          },
          channelState: {
            rules: [
              { required: true, message: '请输入销售渠道状态!'},
            ]
          },
          channelCode: {
            rules: [
              { required: true, message: '请输入销售渠道代码!'},
            ]
          },
        },
        url: {
          add: "/sales/salesChannel/add",
          edit: "/sales/salesChannel/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'channelName','channelState','channelCode'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'channelName','channelState','channelCode'))
      },

      
    }
  }
</script>